<template>
	<div class="point-dialog">
		<el-dialog
		  title="选择自提点"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false" v-loading="pointLoad"
		>
			<div class="product-select">
				<div class="product-select-input el-input el-input-group el-input-group--append">
					<input type="text" 
					  v-model="keyWord"
					  @keyup.enter="_search()"
					  autocomplete="off" placeholder="自提点关键词搜索" maxlength="20" class="el-input__inner">
					<div class="el-input-group__append">
						<button type="button" class="el-button product-select-btn el-button--default" @click="_search">
							<span>查询</span>
						</button>
					</div>
				</div>
			</div>
			<div v-if="list.length > 0">
				<div class="pop-list">
					<el-checkbox-group class="goods_checkbox" v-model="goods_checkbox" @change="handleCheckedChange">
						<div class="pop-item" v-for="(item, index) in list" :key="item.id">
							<el-checkbox :label="item.id"></el-checkbox>
							<img class="pop-cover" :src="item.cover_url" v-if="item.cover" alt="">
							<div class="headimg_font" v-else>{{item.name.substring(0,4)}}</div>
							<div class="pop-info">
								<div style="display: flex;width: 40vw;">
									<div class="pro-title _aline">{{item.name}}</div>
									<div class="_phone">{{item.phone}}</div>
								</div>
								<div class="pro-price _aline">
									{{item.city}}{{item.county}}{{item.address}}
								</div>
							</div>
						</div>
					</el-checkbox-group>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
					<!-- 分页器 -->
					<div class="block" style="padding: 30px 30px 10px 30px;" v-if="list.length > 0">
						<el-pagination background align="center" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
							layout="total, prev, pager, next" :pager-count="5" :total="total">
						</el-pagination>
					</div>
					<el-button style="width: 110px;margin-top: 20px;" type="primary" @click="confirm()" :disabled="goods_checkbox.length == 0">确定</el-button>
				</div>
			</div>
			<div class="empty" v-else>
				<img src="../../assets/img/promotion/ztd_empty.png">
				<div>没有可选择的自提点，您可前往自提点管理进行添加</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getPointList
	} from '@/api/event';
import { forEach } from 'core-js/fn/dict';
	export default {
		data() {
			return {
				keyWord:'', // 搜索关键字
				list:[], // 当前页面数据
				goods_all: [], // 所有数据（多页）
				goods_checkbox: [], // 复选框数据
				currentPage: 0, // 当前页码
				pageSize: 10, // 每页的数据条数
				total: 0, // 总数
				checkAll:false, // 全选状态
				isIndeterminate:false,
				checkPoints:[], // 选中的自提点
				checked1: true,
				pointLoad:false, // 加载动画
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			check_point_id: {
				type: Array,
				default: [],
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.getInfo();
				}
			}
		},
		methods: {
			close() {
				this.list = [];
				this.keyWord = '';
				this.currentPage = 0;
				this.goods_all = [];
				this.goods_checkbox = [];
				this.$emit('close');
			},
			// 全选按钮改变事件
			handleCheckAllChange(val) {
				var that = this;
				this.isIndeterminate = false;
				if(val){
					that.list.forEach(function (item) {
						var ind = that.goods_checkbox.indexOf(item.id);
						if(ind == -1){
							that.goods_checkbox.push(item.id);
						}
					})
				}else{
					that.list.forEach(function (item) {
						var ind = that.goods_checkbox.indexOf(item.id);
						if(ind > -1){
							that.goods_checkbox.splice(ind,1);
						}
					})
				}
			},
			// 复选框改变事件
			handleCheckedChange(value) {
			  var that = this;
			  //当前页的选中的数量
			  let checkedCount = 0;
			  that.list.forEach(function (item) {
				that.goods_checkbox.forEach(function (check_item) {
					if(item.id == check_item){
						checkedCount++;
					}
				})
			  })
			  console.log(checkedCount);
			  
			  this.checkAll = checkedCount >= this.list.length;
			  this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
			  console.log(this.goods_checkbox);
			  
			},
			getInfo() {
				this.pointLoad = true;
				getPointList({
					check_point_id: this.check_point_id,
					page: this.currentPage,
					pageSize: this.pageSize,
					key: this.keyWord
				}).then(res => {
					if (res.code == 0) {
						this.list = res.data.list;
						this.total = res.data.allcount;
						this.goods_all = this.goods_all.concat(res.data.list)
						//重新判断全选按钮状态
						this.isIndeterminate = false;
						this.handleCheckedChange(this.goods_checkbox);
						
					} else {
						this.$message.error(res.message);
					}
					this.pointLoad = false;
				})
			},
			// 选中
			confirm() {
				if (this.goods_checkbox.length == 0) {
					return false;
				}
				var goods_all = this.goods_all;
				var points = [];
				this.goods_checkbox.forEach(function (item) {
					for (var i = 0;i < goods_all.length;i++) {
						if (item == goods_all[i].id) {
							points.push({
								id: goods_all[i].id,
								name: goods_all[i].name
							})
							break;
						}
					}
				})
				
				this.goods_checkbox = [];
				// this.proKeyWord = '';
				// this.checkPoints = points;
				this.$emit('confirm', points);
				this.close();
			},
			// 搜索产品
			_search(){
				this.getInfo();
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfo();
			},
		},
		mounted() {
		}
	}
</script>

<style scoped>
	.product-select{
		margin-bottom: 20px;
	}
	.product-select .product-select-btn{
		width: 100px;
		color: #1989FA;
		background: #E6F1FC;
	}
	
	.goods_checkbox >>> .el-checkbox__label {
		display: none;
	}
	.goods_checkbox >>> .el-checkbox {
		padding: 11px 20px 11px 0;
	}
	.pop-list {
		height: 300px;
		overflow-y: scroll;
	}
	.pop-item {
		padding: 10px 10px 10px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
	}
	.pop-cover {
		width: 40px;
		height: 40px;
		min-width: 40px;
		min-height: 40px;
		max-width: 40px;
		max-height: 40px;
		border-radius: 2px;
	}
	.pop-info {
		margin-left: 10px;
	}
	.pro-title {
		width: 33vw;
		font-size: 14px;
		font-weight: bold;
		color: #333333;
		line-height: 14px;
		padding-right: 1vw;
	}
	._phone{
		font-size: 12px;
		color: #666666;
	}
	.pro-price {
		font-size: 12px;
		font-weight: 500;
		color: #666666;
	}
	.input-error >>> .el-input__inner, .input-error >>> .el-input__inner:focus {
		border-color: #F56C6C;
	}
	.empty {
		width: 100%;
		height: 400px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	._aline{
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		word-break: break-word;
	}
	.headimg_font{
		width: 40px;
		height: 40px;
		min-width: 40px;
		min-height: 40px;
		max-width: 40px;
		max-height: 40px;
		border-radius: 2px;
		background:RGBA(230, 237, 254, 1);
		font-size: 14px;
		color: #5084F5;
		box-sizing: border-box;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		word-break: break-all;
	}
</style>